import { render, staticRenderFns } from "./RequestRenewal.vue?vue&type=template&id=41f70b7c"
import script from "./RequestRenewal.vue?vue&type=script&lang=js"
export * from "./RequestRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports